import { render, staticRenderFns } from "./WidgetsAdminCostPaymentBucket.vue?vue&type=template&id=34a1be06"
import script from "./WidgetsAdminCostPaymentBucket.vue?vue&type=script&lang=js"
export * from "./WidgetsAdminCostPaymentBucket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports